var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / VU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 12,
    width: 28,
    height: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-18.8%",
    width: "110.7%",
    height: "137.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 28,
    height: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-18.8%",
    width: "110.7%",
    height: "137.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-VU",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#009543",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D21034",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 8,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83",
    fill: "#262626",
    mask: "url(#mask-2)",
    points: "0 0 13.3333333 10 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.666666667,2.63717049 L9.52802034,10 L-0.666666667,17.3628295 L-0.666666667,2.63717049 Z",
    id: "Rectangle-83",
    stroke: "#FDCE12",
    strokeWidth: 1.33333333,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FDCE12",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 9.33333333,
    width: 18.6666667,
    height: 1.33333333
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVu);
export default __webpack_public_path__ + "static/media/VU.4c04c9bb0f3c32d0637e22eb71891d55.svg";
export { ForwardRef as ReactComponent };